import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { withAutomationsCategory } from './automationsAnalytics';
import META from './useTrackAutomationDeleted.meta';

export type UseTrackAutomationDeletedParams = {
  automation_id: string;
};

export const useTrackAutomationDeleted = () => {
  const { track } = useAnalyticsUtilities();

  const trackAutomationDeleted = useCallback(
    (params: UseTrackAutomationDeletedParams) => {
      track(META.name, withAutomationsCategory(params));
    },
    [track],
  );

  return { trackAutomationDeleted };
};
